<template>
    <div class="course-box">
        <!-- <el-menu mode="horizontal" :default-active="activeIndex" @select="OnMenuSelect">
            <el-menu-item v-for="item in courseMentList" :key="item.id" :index="item.id+''">{{item.name}}</el-menu-item>
        </el-menu> -->
        <div class="max-width-box">
            <h1>Results for "{{query}}"</h1>
        </div>
        <SearchTop :resultCount="resultCount" @searchChange="defaultParmasChange"></SearchTop>
        <RecommendCourses style="margin-top:16px;" :courseList="courseList"></RecommendCourses>
        <div v-if="defaultParmas.page<page_count" class="view-more">
            <el-button @click="loadMore">VIEW MORE COURSES</el-button>
        </div>
    </div>
</template>

<script>

import SearchTop from "./Component/SearchTop";
import RecommendCourses from "./Component/RecommendCourses";
import KtPag from "@/views/Comm/KtPag";
import { mapState } from "vuex";
export default {
    components: {
        RecommendCourses,
        SearchTop,
        KtPag
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.app.userInfo,
            schoolId: (state) => state.app.schoolId,
            navTree: (state) => state.menu.navTree,
        }),
    },
    data() {
        return {
            courseList: [],
            defaultParmas: {
                page: 1,
                limit: 15
            },
            resultCount: '0 courses',
            page_count: 0,
            courseMentList: [],
            activeIndex: '',

            query: '',
            source: '',

        };
    },
    watch: {
        '$route.query': function (newVal, oldVal) {
            this.initPage();
        },
        'schoolId': function (newVal, oldVal) {
            this.getMoreCourses();
        }
    },
    mounted() {
        for (let item of this.navTree) {
            if (item.name === 'Courses') {
                this.courseMentList = item.children;
                break;
            }
        }
    },
    created() {
        this.initPage();
    },
    methods: {
        initPage() {
            this.source = this.$route.query?this.$route.query.source:'';
            this.query = this.$route.query?this.$route.query.query:'';
            this.getMoreCourses();

        },
        OnMenuSelect(index) {
            this.$router.push({
                url: this.$route.fullpath,
                query: {
                    courseType: index
                }
            })
        },
        defaultParmasChange(data){

            this.defaultParmas = Object.assign({}, this.defaultParmas, data);
            this.getMoreCourses();
        },

        getMoreCourses() {
            let { courseType,query } = this.$route.query;
            let params = {
                courseType: courseType,
                ...this.defaultParmas,
                searchcourse: query,
                schoolId: this.schoolId
            }
            if(!this.userInfo.id){
                delete params.schoolId
            }
            delete params.queryStr;
            this.$api.courseApi.getCourses(params).then(res => {
                if (res.status === "0") {
                    res.data.rows.forEach(item => {
                        item.courseImg = JSON.parse(item.courseImg || '[]')
                    })
                    this.courseList = res.data.rows;

                    this.page_count = Math.ceil(res.data.count / this.defaultParmas.limit);
                    this.resultCount = res.data.count + ' courses';
                }
            });
        },
        loadMore() {
            this.defaultParmas.page++;
            let { courseType } = this.$route.query;
            let params = {
                courseType: courseType,
                ...this.defaultParmas,
                searchcourse: this.defaultParmas.queryStr,
                schoolId: this.schoolId
            }
            delete params.queryStr;
            this.$api.courseApi.getCourses(params).then(res => {
                if (res.status === "0") {
                    res.data.rows.forEach(item => {
                        item.courseImg = JSON.parse(item.courseImg || '[]')
                    })
                    this.courseList = this.courseList.concat(res.data.rows);
                }
            })
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/utils/vw.scss";
// @media only screen and (min-width: 1600px){
//     .headbar{
//         max-width: 1400px;
//     }
// }
// @media only screen and (min-width: 2000px){
//     .headbar{
//         max-width: 1600px;
//     }
// }
$navColor: #fff;
.course-box {
    // background: #f0f2f5;
    /deep/.search-te-co-box{
        .te-search-box{
            display: none;
            margin: 0 auto;
        }
        .te-count-sort{
            margin-top: 0px;
        }
    }
    padding-bottom: 32px;
    .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom-color: #f48c06;
    }
    .el-menu {
        width: calc(100vw - 17px);
        left: 0;
        position: absolute;
        display: flex;
        justify-content: center;
        .el-menu-item {
            font-size: 16px;
            padding: 0;
            margin: 0 20px;
        }
    }
    .view-more {
        margin: vw(40) 0 0 0;
        padding: 0 0 vw(96) 0;
        text-align: center;
        .el-button {
            width: vw(312);
            height: vw(48);
            background: #f48c06;
            border-radius: 32px;
            color: #ffffff;
            line-height: vw(20);
            font-weight: 600;
            font-size: vw(20);
            border: none;
        }
    }
}
</style>